import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field"]

  fieldTargetConnected(element) {
    element.focus({ preventScroll: true })
  }
}
